import { atom, useRecoilState, useResetRecoilState } from "recoil";

import { API_FETCH_STATUS } from "constants/common";
import Environment from "services/environment";
import RestApiCall from "interceptor/aeh";

const { SUCCESS, LOADING, ERROR } = API_FETCH_STATUS;
const env = Environment.getEnv();
const queryParam = { nameSpace: "AIRTEL_THANKS_FOR_BUSINESS" };

const EXPERIMENT_INITIAL_STATE = {
  state: LOADING,
  contents: {},
};

const abExperimentAtoms = {}; 

const abExperimentAtom = (experimentName) => {
  if (!abExperimentAtoms[experimentName]) {
    abExperimentAtoms[experimentName] = atom({
      key: `abExperimentAtom_${experimentName}`,
      default: { state: LOADING, contents: {} },
    });
  }
  return abExperimentAtoms[experimentName];
}

const fetchUserABExperiment = (params) => {
  let apiPayload = {
    method: "GET",
    url: "user/experiment/v1/determine",
    baseURL: env.profileBaseUrl,
    config: { ivUser: env.ivUser },
    params,
  };
  return RestApiCall.api(apiPayload);
};

const useABExperiment = (experimentName) => {
  const getAbExperimentAtom = abExperimentAtom(experimentName)
  const [experimentState, setExperimentState] = useRecoilState(getAbExperimentAtom);
  const resetExperimentState = useResetRecoilState(getAbExperimentAtom);

  const updateStateProperties = (updatedProperties) => {
    setExperimentState((state) => ({ ...state, ...updatedProperties }));
  };

  const fetchExperimentDetails = async () => {
    try {
      const res = await fetchUserABExperiment({ ...queryParam, experimentName });
      if(res.data && !res.data.code){
        updateStateProperties({ state: SUCCESS, contents: res.data });
      }
      return res;
    } catch (error) {
      updateStateProperties({ ...EXPERIMENT_INITIAL_STATE, state: ERROR });
    }
  };

  return { fetchExperimentDetails, experimentState, resetExperimentState };
};

export default useABExperiment;
